import React from "react";

const CustomInput = ({
  type = "text",
  label = "",
  name = "",
  placeholder = "",
  value = "",
  length = 100,

  onChange = () => {},
}) => {
  return (
    <div className="w-full h-fit flex flex-col space-y-[2%]">
      <label
        htmlFor={name}
        className="font-normal text-[1vw] text-textSecondaryColor"
      >
        {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        maxLength={length}
        min={0} // Minimum 0
        max={999999} // Maximum 6 digits
        className="input-primary"
      />
    </div>
  );
};

export default CustomInput;
